

export class EncryptionDecryptionKeyValues {
    public static readonly packingKeyCheckValue: string = "c42963b150bf47ad";
}